import $ from 'jquery'
import _ from 'underscore'
import StateManager from '../scuba/StateManager'

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
  $(node)
    .find('.js-accordion')
    .each(function(i, el) {
      new Accordion(el)
    })
})

/* --------------------------------------------------
    CLASS
-------------------------------------------------- */

function Accordion() {
  this.initialize.apply(this, arguments)
}

$.extend(Accordion.prototype, {
  initialize: function(el) {
    var self = this
    self.uid = _.uniqueId('scuba-')
    self.$el = $(el)

    self.$el.find('.js-accordion__toggle').on('click', e => {
      self.$el.toggleClass('is-open')
      e.preventDefault()
    })
  }
})



// WEBPACK FOOTER //
// ./scripts/components/Accordions.js